import Vue from 'vue'
import Vuex from 'vuex'
import config from './config'

Vue.use(Vuex)

const CSV_SEP = ';'

const defaultState = {
  scores: [
    0,
    0,
    0,
    0
  ],
  finalStates: [
    {},
    {},
    {},
    {}
  ],
  locks: [
    false,
    false,
    true,
    true
  ],
  userData: {
    name: '',
    companyName: '',
    maxScores: [],
    totalScore: 0,
    prize: '',
    startTime: ''
  },
  userHistory: [
  ],
  popups: {
    firstFail: false,
    analyticsChallenge: 0
  }
}

if (config.offline && !config.leaderboard) {
  defaultState.locks = [false, false, false, false]
}

const baseState = JSON.parse(JSON.stringify(defaultState))

const storage = window.localStorage

const prefix = 'game2.'
for (const key in baseState) {
  if (storage.getItem(prefix + key)) {
    if (key === 'userData') {
      storage.setItem(prefix + key, defaultState[key])
      continue
    }
    defaultState[key] = JSON.parse(storage.getItem(prefix + key))
  }
  if (config.offline && !config.leaderboard) {
    defaultState[key] = JSON.parse(JSON.stringify(defaultState[key]))
  }
}

const csvValue = function (value) {
  if (value === null || value === undefined || (value + '').trim() === '') {
    return ''
  }
  if ((value + '').match(/^[0-9]+$/)) {
    return value
  }
  return '"' + value.replace(/"/g, '""') + '"'
}

const store = new Vuex.Store({
  state: defaultState,
  mutations: {
  },
  actions: {
    store: function () {
      for (const key in defaultState) {
        storage.setItem(prefix + key, JSON.stringify(defaultState[key]))
      }
    },
    saveFiles: function () {
      let userExists = false
      const userData = JSON.parse(JSON.stringify(this.state.userData))
      for (const user in this.state.userHistory) {
        if (
          this.state.userHistory[user].name.toLowerCase() === this.state.userData.name.toLowerCase() &&
          this.state.userHistory[user].companyName.toLowerCase() === this.state.userData.companyName.toLowerCase()
        ) {
          userExists = true
          this.state.userHistory[user] = userData
        }
      }
      if (!userExists && this.state.userData.totalScore) {
        this.state.userHistory.push(userData)
      }
      if (window.writeFile) {
        const userlist = []
        const header = ['name', 'companyName', 'finalscore', 'ch1', 'ch2', 'ch3', 'prize']
        userlist.push(header.join(';'))
        for (const user in this.state.userHistory) {
          const row = []
          const userData = this.state.userHistory[user]
          row.push(csvValue(userData.name))
          row.push(csvValue(userData.companyName))
          row.push(csvValue(userData.totalScore))
          row.push(csvValue(userData.maxScores[1]))
          row.push(csvValue(userData.maxScores[2]))
          row.push(csvValue(userData.maxScores[3]))
          row.push(csvValue(userData.prize))
          userlist.push(row.join(CSV_SEP))
        }
        window.writeFile('./userlist.json', JSON.stringify(this.state.userHistory, null, ' '))
        window.writeFile('./userlist.csv', userlist.join('\n'))
      }
    },
    clearUserSession: function () {
      if (this.state.userData.name) {
        store.dispatch('saveFiles')
      }
      for (const key in baseState) {
        if (key === 'userHistory') {
          continue
        }
        defaultState[key] = JSON.parse(JSON.stringify(baseState[key]))
        storage.setItem(prefix + key, JSON.stringify(baseState[key]))
      }
    }
  }
})

fetch('../userlist.json')
  .then(response => response.json())
  .then(userlist => {
    store.state.userHistory = userlist
    storage.setItem(prefix + 'userHistory', JSON.stringify(userlist))
    fetch('../userlist.csv')
      .then(response => response.text())
      .catch(() => {
        store.state.userHistory = []
        storage.setItem(prefix + 'userHistory', JSON.stringify([]))
      })
  })
// window.st = store

window.onWindowClose = function () {
  store.dispatch('clearUserSession')
}

window.str = store

export default store
